import React, { useState, useEffect } from 'react';
import {
  Input,
  Modal,
  Tooltip,
  Button,
  Typography,
  Row,
  Col,
  Form,
} from 'antd';
import { incrementUIRequestsCounter } from '../../redux/utils/websocket/incrementUIRequestsCounter';

const DeleteRecipeModal = ({ entityType, entityName, ...props }) => {
  const { Text } = Typography;
  const { isDeleteModalVisible, loadedRecipe } = props;
  let title = props.title;
  if (!title) {
    title = 'Are you sure you want to delete this recipe?';
  }
  let description = props.description;
  if (!description) {
    description = `You are about to delete your ${loadedRecipe?.name} recipe. This action cannot be undone.`;
  }

  return (
    <Modal
      title={title}
      centered
      width={400}
      closable={false}
      open={isDeleteModalVisible}
      footer={[
        <Button
          danger
          key="submit"
          type="primary"
          onClick={() => {
            props?.handleOk(props?.type);
            incrementUIRequestsCounter();
          }}
          disabled={false}
        >
          Delete
        </Button>,
        <Button key="cancel" type="link" onClick={() => props?.handleCancel()}>
          Cancel
        </Button>,
      ]}
    >
      <Text centered>{description}</Text>
    </Modal>
  );
};

export default DeleteRecipeModal;
